import React from 'react';
import { List, Button, Space } from 'antd';
import { icons } from 'antd/es/image/PreviewGroup';

const Cart = ({ cart, onRemoveNumber, onSetForm, setSelectedNumber }) => {
  const handleFormDisplay = (number) => {
    setSelectedNumber(number);
    onSetForm(true);
  };

  return (
    <div className="cart" style={{ marginBottom: '20px' }}>
      <h3>Tu Carrito</h3>
      <List
        bordered
        dataSource={cart}
        renderItem={(number) => (
          <List.Item
            actions={[
              <Button  type="link" icon={icons.close} onClick={() => onRemoveNumber(number)}>Liberar</Button>,
            ]}
          >
            {number}
          </List.Item>
        )}
      />
    </div>
  );
};

export default Cart;
